'use client'

import React from 'react'
import {
  RiUploadCloud2Line,
  RiCheckLine,
  RiErrorWarningLine,
  RiLoader4Line,
} from 'react-icons/ri'
import { AnimatePresence, motion } from 'motion/react'
import Text from 'components/ui/Text'

const NotificationIsland = ({ type, message, hasNotification }) => {
  let icon
  let iconColor

  switch (type) {
    case 'uploading':
      icon = <RiUploadCloud2Line className="animate-pulse" />
      iconColor = 'text-primary dark:text-dark-primary'
      break
    case 'success':
      icon = <RiCheckLine />
      iconColor = 'text-green-500'
      break
    case 'error':
      icon = <RiErrorWarningLine />
      iconColor = 'text-red-500'
      break
    case 'loading':
      icon = <RiLoader4Line className="animate-spin" />
      iconColor = 'text-blue-500'
      break
    default:
      icon = <RiUploadCloud2Line />
      iconColor = 'text-primary'
  }

  return (
    <AnimatePresence>
      {hasNotification && (
        <div className="flex justify-center items-center w-full fixed z-[120] top-0 h-24">
          <motion.div
            initial={{ transform: 'translateY(-200px)' }}
            animate={{ transform: 'translateY(0)' }}
            exit={{
              transform: 'translateY(-200px)',
              transition: { delay: 2 },
            }}
            transition={{ type: 'spring' }}
            className="flex items-center shadow-lg bg-white dark:bg-dark-surface border border-slate-200/50 dark:border-dark-border rounded-full"
          >
            {/* Icon */}
            <div
              className={`relative p-3 rounded-full bg-white dark:bg-dark-surface z-20 ${iconColor}`}
            >
              {React.cloneElement(icon, { size: 32 })}
            </div>

            <AnimatePresence>
              {hasNotification && (
                <motion.div
                  initial={{
                    maxWidth: '0px',
                    margin: 0,
                    transform: 'translateX(-40px)',
                  }}
                  animate={{
                    maxWidth: '1000px',
                    margin: 12,
                    transform: 'translateX(0px)',
                  }}
                  exit={{
                    maxWidth: '0px',
                    margin: 0,
                    transform: 'translateX(-40px)',
                  }}
                  transition={{ delay: 2, type: 'spring', stiffness: 100 }}
                  className="overflow-hidden z-50"
                >
                  <Text className="whitespace-nowrap pr-4">{message}</Text>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}

export default NotificationIsland
